import { FormGroup } from '@angular/forms';

export const getErrorMessage = (controlName: string, formGroup: FormGroup, requiredMessage?: string): string => {
    const control = formGroup.get(controlName);
    if (!control?.touched || !control?.errors) {return '';}

    const errorType = Object.keys(control.errors)[0];
    const errors = control.errors;

    switch (errorType) {
    case 'required': {
        return requiredMessage || 'Поле обязательно для заполнения';
    }

    case 'maxlength': {
        const maxLength = control.getError('maxlength').requiredLength;
        return `Максимальная длина — ${maxLength} символов`;
    }

    case 'minlength': {
        const minLength = control.getError('minlength').requiredLength;
        return `Минимальное значение — ${minLength} символов`;
    }

    case 'min': {
        const minValue = errors['min'].min;
        return `Минимальное значение — ${minValue}`;
    }

    case 'max': {
        const maxValue = errors['max'].max;
        return `Максимальное значение — ${maxValue}`;
    }
    default: {
        return 'Некорректное значение';
    }
    }
};
